export const MANUAL_SPOT_LIBRARY_SUFFIX = '§lib_'
